import { useCallback, useRef } from 'react';

let start;
let rafId;

const usePollAnimationFrame = () => {
  const flag = useRef<'start' | 'end'>('start');

  const endPoll = useCallback(() => {
    if (rafId) {
      flag.current = 'end';

      window.cancelAnimationFrame(rafId);
      rafId = null;
      start = undefined;
    }
  }, []);

  const startPoll: (fn: () => Promise<any>, codeList: Array<number>) => Promise<any> = useCallback(
    (fn, codeList) => {
      flag.current = 'start';

      return new Promise((resolve, reject) => {
        const step = (timestamp) => {
          if (start === undefined) {
            start = timestamp;
          }
          const elapsed = timestamp - start;
          // 2s gap
          if (elapsed > 2000) {
            start = timestamp;
            if (typeof fn === 'function') {
              const promise = fn();
              if (typeof promise.then === 'function') {
                promise
                  .then(
                    (res) => {
                      console.log('then=>>>>', res);
                      // 读取成功的条件
                      if (codeList?.includes(res.code)) {
                        if (rafId) {
                          window.cancelAnimationFrame(rafId);
                          rafId = undefined;
                          start = undefined;
                        }
                        resolve(res);
                      } else {
                        // 不成功继续轮训
                        if (flag.current === 'start') {
                          rafId = window.requestAnimationFrame(step);
                        }
                      }
                    },
                    () => {
                      console.log('throw=>>>>');
                      throw new Error('requestAnimationFrame promise error');
                    },
                  )
                  .catch(() => {
                    // 异常取消
                    if (rafId) {
                      window.cancelAnimationFrame(rafId);
                      rafId = undefined;
                      start = undefined;
                    }
                    reject(new Error('poll失败'));
                  });
              }
            }
          } else {
            if (flag.current === 'start') {
              rafId = window.requestAnimationFrame(step);
            }
          }
        };

        rafId = window.requestAnimationFrame(step);
      });
    },
    [],
  );

  return {
    startPoll,
    endPoll,
  };
};

export default usePollAnimationFrame;
